export default function AdSetting(){
    return (
        <div className="NotF">
          Settings
        </div>
    )
}